export { default } from './ProductCardParamsBasicFull';
